<template>
  <div>
    <div class="card" style="width:645px">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Booking Travel for {{ payload.traveler.profile.firstName }} {{ payload.traveler.profile.lastName }}... </p>
        </header>
        <section class="modal-card-body">
          <template>
            <section class='my-4 '>
              Status: {{ description | capitalize }}
<!--              <b-progress :value="status" size="is-medium" type="is-primary" show-value>-->
<!--                  {{description}}-->
<!--              </b-progress> -->
              <div v-if="info && description !='failed'">
                <div v-for='action in info.stages' :key="action.name">
                  <!-- <b-loading :is-full-page="false" v-model="action.isComplete" :can-cancel="false" > -->
                  <div class="card-content">
                    <div class="media">
                      <div class="media-left">
                        <ClipLoader :loading='!action.isComplete' color="grey" size="25px"/>
                        <b-icon v-if="action.isComplete"
                                icon="check"
                                type="is-success"
                                size="is-medium">
                        </b-icon>
                      </div>
                      <div class="media-content is-size-6">
                        <p> {{ action.name }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- </b-loading> -->
                </div>
              </div>
              <div v-if="description =='failed'">
                <div class="my-4">
                  <h3 class="is-size-4 mb-2">Booking Failed</h3>
                  <p class="mb-5 notification is-light is-danger">We encountered an error with your booking and it has
                    not been completed. Please try to submit your booking again or contact us using one of the methods
                    below to complete your booking.</p>
                  <p class="mb-2">Email Gant's Online Team:
                    <a href="mailto:clientservices@ganttravel.com">
                      clientservices@ganttravel.com
                    </a>
                  </p>
                  <p class="mb-2">Contact Gant Travel directly for agent assistance at 877-924-0303</p>
                </div>
              </div>
            </section>
          </template>
        </section>

<!--        <footer class="modal-card-foot columns my-1 py-0">-->
<!--          <div class="column">-->
<!--          </div>-->
<!--          <div class="column is-2">-->
<!--            <b-button-->
<!--                v-if="description == 'failed'"-->
<!--                label="Close"-->
<!--                @click="$emit('failed')"-->
<!--                type="is-primary"/>-->
<!--            &lt;!&ndash; <b-button-->
<!--                v-if="description == 'completed'"-->
<!--                label="View your trip"-->
<!--                @click="goPNR"-->
<!--                type="is-primary" /> &ndash;&gt;-->
<!--          </div>-->
<!--        </footer>-->
      </div>
    </div>
  </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import bookingMixin from "../../mixins/bookingMixin";

export default {
  name: 'PNRPending',
  mixins: [bookingMixin],
  components: {
    ClipLoader
  },
  props: {
    payload: Object
  },
  data: function () {
    return {
      status: 0,
      key: null,
      intervalID: null,
      description: '',
      info: null,
    }
  },
  computed: {
    isMeetingMode() {
      if (this.$store.state.meetings.meetingInfo) {
        return true;
      }
      return false;
    },
    bookingKey() {
      return this.payload.bookingKey;
    },
    updatingTime() {
      return this.$appConfig.updatingTimePNR || 3000;
    },
    timeLimit() {
      return this.$appConfig.timeLimitPNR || 120000;
    }
  },
  methods: {
    checkStatus() {
      //if (this.bookTrip.currentlyBooking || this.$route.path == '/summary' || this.$route.path == '/meetings/summary') {
        console.log('status check')
        var self = this
        var body = {bookingKey: this.bookingKey}
        this.$app.huddleLabsServerCall('amadeus/pnr/multi-checkout/status', body)
            .then(result => {
                  console.log(result);
                  this.info = result
                  this.description = result.status

                  if (result.status == 'completed' || result.status == 'failed') {
                    console.log('booking completed');
                    //this.status = 100
                    clearInterval(self.intervalID);
                    this.$emit('complete', result);
                  /*
                  } else if (result.status == 'failed') {
                    this.$emit('failed', result);
                    console.log('booking failed');
                    clearInterval(self.intervalID);

                  */  
                  } else {
                    console.log('booking still pending');
                  }
            })
      //}
    },
    /*
    goPNR() {
      // clear booking state
      this.$store.dispatch('bookTravel/clearBooking', {});
      //
      this.$store.commit('pnr/SET_PNR_PENDING', false);
      this.$store.commit('pnr/SET_PNR_INFO', this.info);

      if (this.isMeetingMode) {
        this.$router.push({path: '/meetings/confirmation'})
      } else {
        this.$router.push({path: '/pnr'})
      }
    },
    */
    timeout() {
      if (this.description != 'completed') {

        clearInterval(this.intervalID)
        var _this = this

        setTimeout(() => {
          _this.description = 'failed'
        }, this.updatingTime)

        let result = {
          bookingKey: this.bookingKey,
          status: "failed"
        };

        if (this.info){
          result = this.info;
        }
        
        this.$emit('complete', result)

      }

    },
  },
  mounted() {
    this.intervalID = setInterval(this.checkStatus, this.updatingTime);
    this.intervalOFF = setTimeout(this.timeout, this.timeLimit);
  },
  beforeDestroy() {
    clearInterval(this.intervalID);
  },
}

</script>

<style scoped>
  .column_wrapper {
  max-height: 200px;
  display: flex;
  flex-flow: column wrap;
}
</style>
